import React from 'react';
import Select from 'react-select';
import { SelectionValue } from '@components/library/inputs/Input.props';
import { Portal } from '@api/v4/private/PortalTypes';
import { Privacy } from '@api/v4/resources/resourceTypes';

interface PortalFormStage2Props {
  libraryName: string;
  portal: Portal;
  setPortal: SetStateDispatch<Portal>;
  stage: number;
}

const PortalFormStage2: React.FunctionComponent<PortalFormStage2Props> = ({
  libraryName,
  portal,
  setPortal,
  stage,
}) => {
  if (stage !== 2) { return null; }

  return (
    <div>
      <h3 className="portal-form-modal__title">{bfTranslate('Privacy Settings')}</h3>
      <Select
        className="portal-form-modal__privacy-dropdown"
        onChange={(option: SelectionValue): void => {
          const privacy = option.value as Privacy;
          setPortal((prevState): Portal => ({ ...prevState, privacy }));
        }}
        options={[
          { value: Privacy.Public, label: bfTranslate("Public") },
          { value: Privacy.Private, label: bfTranslate("Private") },
          { value: Privacy.Stealth, label: bfTranslate("Stealth (Extra Private)") },
        ]}
        value={portal.privacy}
      />
      <h3 className="portal-form-modal__privacy-title bold-label-styling">{bfTranslate('Public')}</h3>
      <p>{bfTranslate('Anyone can access this Brand Portal')}.</p>
      <h3 className="portal-form-modal__privacy-title bold-label-styling">{bfTranslate('Private')}</h3>
      <p>{bfTranslate('This Brand Portal is only accessible to the users you specify')}.</p>
      <h3 className="portal-form-modal__privacy-title bold-label-styling">{bfTranslate('Stealth (Extra Private)')}</h3>
      <p>{bfTranslate(`This Brand Portal is only accessible to the users you specify, and will not show up in Google search results and other areas of your ${libraryName}`)}.</p>
    </div>
  );
};

export default PortalFormStage2;
